import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

// ion:refresh — the regenerate/redo glyph on "CHANGE RELEVANT IMPACTS" / "TRY AGAIN" secondary
// buttons (ticket 7127, screen 18). Brand-gradient stroked.
export const RefreshSvg: React.FC<Props> = ({ size = 18, style, className }) => {
  const colors = useStateSelector((state) => state.theme.colors);
  const id = `refresh_${Math.random().toString(36).slice(2)}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M3.69997 6.90003C5.79111 4.20889 6.79907 3.67013 7.8964 3.45185C8.99372 3.23358 10.1311 3.34561 11.1648 3.77376C12.1985 4.20192 13.0819 4.92698 13.7035 5.85725C14.3251 6.78751 14.6569 7.88121 14.6569 9.00004C14.6569 10.1189 14.3251 11.2126 13.7035 12.1428C13.0819 13.0731 12.1985 13.7982 11.1648 14.2263C10.1311 14.6545 8.99372 14.7665 7.8964 14.5482C6.79907 14.33 5.79111 13.7912 4.99998 13.0001"
        stroke={`url(#${id})`}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.07764 3.57812V6.94154H6.44105"
        stroke={`url(#${id})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={id} x1="9" y1="1" x2="2.33" y2="13.09" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
